import * as React from 'react';
import Ellipsis from 'ant-design-pro/lib/Ellipsis';
import { getCurrency, nullSafeGet, nullSafeGetOrElse } from '../../utils/DataAccessUtils';
import { QUOTE_STATUS_DISPLAY_NAMES } from '../../constants/QuoteStatuses';
import { getContactName } from '../../utils/DataFormatterUtils';
import QuoteDisplayStatusDisplay from '../quote_display_status_display/QuoteDisplayStatusDisplay';
import DateTimeHover from '../date_time_component/DateTime';
import { getSanitisedWorkOrder } from '../../utils/WorkOrderUtils';
import { getQuoteOtherCompanyEntity, isClientQuoteView } from '../quote_utils/QuoteUtils';

require('./QuoteRowDisplay.less');

export const QuoteRowDisplay: React.FC<any> = ({ quote, location, currentUser, ...props }) => {
	const wo = getSanitisedWorkOrder(quote.workOrder, isClientQuoteView(quote, currentUser));
	const otherFacility = getQuoteOtherCompanyEntity(quote, currentUser);
	return (
		<div className="quoteRowDisplay" {...props}>
			<div className="rowColumn">
				<div className="rowPrimary" style={{ color: 'rgba(0,0,0,0.65)' }}>
					<Ellipsis
						tooltip={true}
						fullWidthRecognition={true}
						lines={1}
						style={{ paddingBottom: '1px', marginRight: '5%' }}
					>
						{nullSafeGet('title', wo)}
					</Ellipsis>
				</div>
				<div className="rowSecondary">
					<div className="rowInlineGroup">
						<span className="rowGrayChip">
							<i className="icons8-font icons8-location-marker" />
							<span>{nullSafeGet('location.name', wo)}</span>
						</span>
					</div>
					<div className="rowInlineGroup">
						<QuoteDisplayStatusDisplay status={QUOTE_STATUS_DISPLAY_NAMES[quote.status]} />
					</div>
					{nullSafeGet('isCapex', wo) ? (
						<div className="rowInlineGroup">
							<span className={'rowGrayChip'} style={{ padding: '4px 12px', borderRadius: 16 }}>
								<span>CapEx</span>
							</span>
						</div>
					) : null}
					<div className="rowInlineGroup">
						<i className="icons8-font icons8-maintenance-filled" />
						<span>{nullSafeGet('problemType.hierarchyName', wo)}</span>
					</div>
					{nullSafeGet('displayName', otherFacility) ? (
						<div className="rowInlineGroup">
							<i className="icons8-font icons8-company" />
							{nullSafeGet('displayName', otherFacility)}
						</div>
					) : null}
					<div className="rowInlineGroup">{'WO #'.concat(wo.id)}</div>
					{nullSafeGet('buyerProjects.length', wo) === 1 ? (
						<div className="rowInlineGroup">
							<span>
								<i className="icons8-font icons8-blueprint" />
								{nullSafeGet('buyerProjects', wo)[0].title}
							</span>
						</div>
					) : nullSafeGet('buyerProjects.length', wo) > 1 ? (
						<div className="rowInlineGroup">
							<span>
								<i className="icons8-font icons8-blueprint" />
								{nullSafeGet('buyerProjects.length', wo)} Projects
							</span>
						</div>
					) : null}
				</div>
				<div className="rowTertiary rowBlackPrimary mt-2">
					<span style={{ whiteSpace: 'nowrap', color: 'rgba(0,0,0,0.45)', fontSize: 14 }}>
						<>
							Submitted{' '}
							<DateTimeHover
								timestamp={nullSafeGet('createdAt', quote)}
								showTime={false}
								timeZone={nullSafeGet('location.timeZoneId', wo)}
							/>{' '}
							{quote.createdByContact ? `by ${getContactName(quote.createdByContact)}` : ''}
						</>
					</span>
				</div>
			</div>
			<div className="quoteRowDisplay__rightSide">
				<div className="quoteRowDisplay__rowInlineGroup">
					{getCurrency({ workOrder: wo }).format(quote.totalAfterTax)}
				</div>
			</div>
		</div>
	);
};
